module.exports = __webpack_public_path__ + "img/xrc3.02bcabba.png";